import React, { useState,useEffect,useRef } from 'react';
import {Link,useParams} from 'react-router-dom';
import {Row,Col,ListGroup, Image, Button, Card,Form, FormGroup, ListGroupItem, Container } from 'react-bootstrap';
import { FaTruck, FaCreditCard, FaCheckCircle } from 'react-icons/fa';
import { useNavigate,useLocation } from 'react-router-dom'
import Message from '../components/Message';
import Loader from '../components/Loader';
import CheckoutStatusBar from '../components/CheckoutStatusBar.jsx';
import CheckoutStatusBar1 from '../components/CheckoutStatusBar1.jsx';
import { useGetOrderDetailsQuery,useDeliverOrderMutation,usePayOrderMutation,useOrderRequestMutation,useOfferSendMutation,useActivateSendMutation,useCreateOrderMutation} from '../slices/ordersApiSlice';
import { useDispatch,useSelector } from 'react-redux';
import { saveCreditCard } from '../slices/cartSlice'
import accounting from 'accounting-js'
import { useGetCurrencyQuery,useVerifiedMutation } from '../slices/ordersApiSlice';
import Cards from 'react-credit-cards';
import 'react-credit-cards/es/styles-compiled.css'
import DocumentModal from '../components/DocumentModal.jsx';

const OrderScreen = () => {
    const {id: orderId} =useParams();
    const {data: order,refetch, isLoading, error} = useGetOrderDetailsQuery(orderId);
    const [payOrder, { isLoading: loadingPay }] = usePayOrderMutation();
    const [deliverOrder, {isLoading: loadingDeliver}] = useDeliverOrderMutation();
    const [orderRequest,{isLoading: loadingOrder}] = useOrderRequestMutation();
    const [offerSend,{isLoading: loadingOffer}] = useOfferSendMutation();
    const [activateSend,{isLoading: loadingActivate}] = useActivateSendMutation();


    const {userInfo} = useSelector((state)=>state.auth);
    const [tempOrder,setTempOrder] = useState(order);
    const [orderItems,setOrderItems] = useState();
    const [deliverNumber,setDeliverNumber] = useState();
    const[tempItemPrice,setTempItemPrice]= useState();
    const[tempTaxPrice,setTempTaxPrice]= useState();
    const[tempTotalPrice,setTempTotalPrice]= useState();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const[trig,setTrig] = useState();
    
    const [name,setName] = useState('');
    const [cvv,setCvv] = useState('');
    const [expiry,setExpiry] = useState('');
    const [number,setNumber] = useState('');
    const [ip,setIp] = useState('');
    const {data:currency} = useGetCurrencyQuery();
    
    const[formErrors,setFormErrors] = useState({});
    const [isSubmit, setIsSubmit] = useState(false); 
    
    const [createOrder] = useCreateOrderMutation();
    const cart = useSelector((state) => state.cart);
    
    const [paymentMethod,setPaymentMethod] = useState(cart?.paymentMethod || 'Banka Transferi');
    const [data1, setData] = useState('');
    const [verified] = useVerifiedMutation();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isConfirm, setIsConfirm] = useState(false);
    const [isEnable,setIsEnable] = useState(false);
    const [documentContent, setDocumentContent] = useState();

    // Bankaya güvenli 3D Secure formu göndermek için kullanılan gizli form referansları
    // (bkz. PlaceOrderScreen.jsx -> fetchData). Gerçek bir tarayıcı form-submit'i kullanılır.
    const paymentFormRef = useRef(null);
    const orderIdRef = useRef(null);
    const cardNumberRef = useRef(null);
    const expireMonthRef = useRef(null);
    const expireYearRef = useRef(null);
    const cvvRef = useRef(null);
    const cardHolderNameRef = useRef(null);



    let responseData;
    useEffect(() => {
      const fetchIp = async () => {
        try {
          const response = await fetch('https://api.ipify.org');
          const data = await response.text();
          setIp(data);
        } catch (error) {
          console.error('Error fetching IP address:', error);
        }
      };
  
      fetchIp();
    }, []); // Empty dependency array ensures that this effect runs only once on mount

    
      const placeOrderHandler1 = () => {  
        {
    
            setFormErrors(validate());
            console.log(ip);
                  setIsSubmit(true);
                  dispatch(saveCreditCard({number,name,expiry,cvv,ip}));
   
        }

    }

 
    
    const validate = () => {
        const errors ={};
        if(!name)
        {
          errors.name = "Kart üzerindeki adı soyadı giriniz";
        }
        if(number.length<16)
        {
          errors.number = "Kart Numarası eksik";
        }
        if(!number)
        {
          errors.number = "Kart Numarasını giriniz"
        }
        if(expiry.length<4)
        {
          errors.expiry = "Ay/Yıl eksik";
        }
        if(!expiry ){
          errors.expiry = "Ay/Yıl giriniz"
        }
        if(cvv.length<3)
        {
          errors.cvv = "Cvv Numarası eksik";
        }
        if(!cvv  ){
          errors.cvv = "Cvv numarasını giriniz"
        }  
      return errors;
      }



 

    useEffect(() =>{
    
        if(Object.keys(formErrors).length === 0 && isSubmit)
        {
          fetchData();
        }
      
      },[isSubmit]);
   

      const fetchData = async () =>{
        const updatedOrder = {
            orderId,
            number,   
        };
        try {
            await verified(updatedOrder);
          //  refetch();
         fetchData1();
        //    toast.success('Order delivered');  
          } catch (err) {
        //      toast.error(err?.data?.message || err.message);
          }


      }
   

      // NOT: Eskiden burada MerchantId/UserName/API şifresi tarayıcıda gömülü olarak
      // (apitest/api123, sandbox kimlik bilgileri) HashData hesaplanıp doğrudan bir
      // /calc ekranına yönlendiriliyordu - PCI-DSS açısından güvensiz ve production
      // kimlik bilgilerini de kullanmıyordu. Artık PlaceOrderScreen.jsx -> fetchData
      // ile birebir aynı güvenli akış kullanılıyor: kart bilgileri sadece gizli bir
      // form ile doğrudan /api/payment/initiate'e gidiyor, HashData hesaplama ve API
      // şifresi SADECE backend'de (orderController.js) yer alıyor.
      const fetchData1 = async () => {
        try {
          setTrig("1");

          const expiryString = String(expiry);
          const expireMonth = expiryString.slice(0, 2);
          const expireYear = expiryString.slice(-2);

          orderIdRef.current.value = orderId;
          cardNumberRef.current.value = number;
          expireMonthRef.current.value = expireMonth;
          expireYearRef.current.value = expireYear;
          cvvRef.current.value = cvv;
          cardHolderNameRef.current.value = String(name).toUpperCase();

          paymentFormRef.current.submit();
        } catch (error) {
          setTrig('');
        }
      }


    if(!userInfo && trig==true)
    {
  
      if(order.user._id == "65b4216620f7fabf737b0c73") 
      {
        navigate(`/order/${orderId}`);
      }
      else{ 

        navigate('/login',
            {
                state: {
                    post_id: orderId,
                }
            });

        }  
    }


  


// TESTING ONLY! REMOVE BEFORE PRODUCTION
   const onApproveTest = async ()=> {
     await payOrder({ orderId, details: { payer: {} } });
     refetch();


   }



const deliverOrderHandler = async () => {
    const updatedOrder = {
        orderId,
        deliverNumber,       
    };
    try {
      await deliverOrder(updatedOrder);
      refetch();
  //    toast.success('Order delivered');  
    } catch (err) {
  //      toast.error(err?.data?.message || err.message);
    }
}

const orderRequestHandler = async () => {
    try {
      await orderRequest(orderId);
      refetch();
      
    //  toast.success('Order Requested');  
    } catch (err) {
    //    toast.error(err?.data?.message || err.message);
    }
}

const offerSendHandler = async () => {
    const updatedOrder = {
        orderId,
        orderItems,
        tempItemPrice,
        tempTaxPrice,
        tempTotalPrice,
       
    };

    try {
      await offerSend(updatedOrder);
      refetch();
    //  toast.success('Offer Send');  
    } catch (err) {
    //    toast.error(err?.data?.message || err.message);
    }  
   
}

const activateSendHandler = async () => {
   
    try {
        await activateSend(orderId);
        refetch();

      } catch (err) {

      }
}



useEffect(() => {
    if (order) {
        setTempOrder(order);
        setOrderItems(order.orderItems);
        activateSendHandler();

        var currentDate = new Date();
        const day = currentDate.getDate();
        const month = currentDate.getMonth() + 1; // Months are zero-based, so add 1
        const year = currentDate.getFullYear();


        //----------------------

         setDocumentContent(
          <div>
      
              <p>
              <h4><strong>MESAFELİ SATIŞ SÖZLEŞMESİ </strong> </h4>
              <p> <strong> MADDE 1 - KONU </strong> </p>
              <Row>
              İşbu sözleşmenin konusu, SATICI'nın, ALICI'ya satışını yaptığı, aşağıda nitelikleri ve satış fiyatı belirtilen ürünün
              </Row>
              <Row>
              satışı ve teslimi ile ilgili olarak Borçlar Kanunu ve/veya Türk Ticaret Kanunu hükümleri gereğince, tarafların hak ve
              </Row>
              <Row>
              yükümlülüklerini kapsamaktadır.
              </Row>
              </p>
               
              
              <p> <strong> MADDE 2.1 - SATICI BİLGİLERİ </strong> </p>
              <p><strong>Ünvan:</strong> ADP ENDÜSTRİYEL OTOMASYON SİSTEMLERİ SAN. ve TİC. LTD. ŞTİ.</p>
              <p><strong>Ticaret Sicil No: 0008-0809-1670-0010 </strong></p>
              <p><strong>Adres: Mandıra Cad. Teker Sok. No:2/D Kadıköy/İstanbul </strong> </p>
              <p><strong>Telefon: 0532 494 84 27</strong></p>
              <p><strong>E-Posta: satis@adpotomasyon.com.tr </strong></p>
              <p> <strong> MADDE 2.2 - ALICI BİLGİLERİ </strong> </p>
              <p><strong>Alıcı: </strong>{order.shippingAddress.companyName} {order.shippingAddress.name} {order.shippingAddress.surname}</p>
              <p><strong>Alıcı Fatura Adresi: </strong>{order.shippingAddress.companyAddress},{order.shippingAddress.companyCity},{order.shippingAddress.companyState}</p>
              {order.shippingAddress.isCompany ==="true" &&  <p><strong>VKN: </strong>{order.shippingAddress.taxNumber}</p>  }
              <p><strong>Alıcı Telefonu: </strong>{order.shippingAddress.phoneNumber}</p>
              <p><strong>Alıcı E-Posta: </strong>{order.shippingAddress.email}</p>
      
              <p> <strong> MADDE 3 - SÖZLEŞME KONUSU ÜRÜN BİLGİLERİ </strong> </p>
              <Row>
                <Col> <strong>Ürün</strong> </Col>
                <Col md={4} ><strong>Toplam Fiyat </strong> </Col>
              </Row>
              <ListGroup variant='flush'>
                        {order.orderItems.map((item, index) => (
                          <ListGroup.Item key={index}>
                            <Row>
                              <Col>
                                  {item.name}
                              </Col>
                              {item.priceShow && item.advertisementShow===false ?( <Col md={4}>
                                {item.qty} x {accounting.formatMoney(item.price - (item.price * (item.discount || 0) / 100),{ symbol: "", precision: 2, thousand: ".", decimal: "," })} ₺ = { accounting.formatMoney(item.qty * (item.price - (item.price * (item.discount || 0) / 100)),{ symbol: "", precision: 2, thousand: ".", decimal: "," })} ₺
                              </Col>):(

                                item.advertisementShow===false ?
                                (<Col md={4}>
                                  {item.qty} x Teklif verilecek
                                  </Col>
                                  ):
                                  (<Col md={4}>
                                    {item.qty} x {accounting.formatMoney(item.price - (item.price * (item.discount || 0) / 100),{ symbol: "", precision: 2, thousand: ".", decimal: "," })} ₺ = { accounting.formatMoney(item.qty * (item.price - (item.price * (item.discount || 0) / 100)),{ symbol: "", precision: 2, thousand: ".", decimal: "," })} ₺
                                    </Col>
                                    )
                              )}
                             
                            </Row>
                          </ListGroup.Item>
                        ))}
            </ListGroup>
              <Card>
             
                  <ListGroup variant='flush'>
                    <ListGroup.Item>
                      <strong>Sipariş Özeti</strong>
                    </ListGroup.Item>
                    <ListGroup.Item>
                      <Row>
                        <Col>Ürünler</Col>
                        <Col>{  accounting.formatMoney(order.itemsPrice,{ symbol: "", precision: 2, thousand: ".", decimal: "," }) +" ₺"}</Col>
                      </Row>
                    </ListGroup.Item>

                    <ListGroup.Item>
                      <Row>
                        <Col>K.D.V(%20)</Col>

                          <Col>{ accounting.formatMoney(order.taxPrice,{ symbol: "", precision: 2, thousand: ".", decimal: "," }) +" ₺" }</Col>


                      </Row>
                    </ListGroup.Item>
                    <ListGroup.Item>
                      <Row>
                        <Col>Genel Toplam Tutar</Col>

                        <Col>
                        <Row> <strong>
                        { order.orderItems.find(item=>item.priceShow === false && item.advertisementShow===false)? ('Teklif verilecek'): (accounting.formatMoney(order.totalPrice,{ symbol: "", precision: 2, thousand: ".", decimal: "," }) + ' ₺') }
                                        </strong>
                        </Row>
                        </Col>
                      </Row>
                    </ListGroup.Item>
                  </ListGroup>
                </Card>
             
                <p></p>
                {(order.isOrdered || order.isPaid) ?(
                <p><strong>Sipariş Numarası:</strong>{order._id}</p>  
                )
                :
                (
                ''
                )}

                {(order.isOrdered || order.isPaid)&&
                  (order.isOrdered)
                  ?
                  (
                    <p><strong>Sözleşme Tarihi: </strong>{order.orderedAt}</p>
                  )
                  :
                  (
                    (order.isPaid) ?(<p><strong>Sözleşme Tarihi: </strong>{order.paidAt}</p>):(<p><strong>Sözleşme Tarihi: </strong>{day}.{month}.{year}</p> )
                    
                  )
                }
               
                <p><strong>Alıcı: </strong>{order.shippingAddress.receiver}</p> 
                <p><strong>Alıcı Sevk Adresi: </strong>{order.shippingAddress.address},{order.shippingAddress.city},{order.shippingAddress.state}</p>
                <p><strong>Kargo Tercihi: </strong>{order.shippingAddress.cargoSelection} Alıcı Ödemeli </p>
          <p>      
          <p> <strong>  MADDE 4 - GENEL HÜKÜMLER </strong> </p>
          <row><strong> 4.1. </strong> ALICI, Madde 3'te belirtilen sözleşme konusu ürün veya ürünlerin temel nitelikleri, satış fiyatı ve ödeme şekli ile</row>
          <row>teslimata ilişkin tüm ön bilgileri okuyup bilgi sahibi olduğunu ve elektronik ortamda gerekli teyidi verdiğini beyan eder.</row>
          </p>
          <p>
          <row><strong> 4.2.</strong>Sözleşme konusu ürün veya ürünler, yasal 30 günlük süreyi aşmamak koşulu ile her bir ürün için ALICI'nın yerleşim yerinin </row>
          <row>uzaklığına bağlı olarak ön bilgiler içinde açıklanan süre dâhilinde ALICI veya gösterdiği adresteki kişi/kuruluşa teslim edilir. Bu süre</row>
          <row>ALICI’ya daha önce bildirilmek kaydıyla en fazla 10 gün daha uzatılabilir.</row>  
          </p>
          <p>
          <row><strong> 4.3.</strong>Sözleşme konusu ürün, ALICI'dan başka bir kişi/kuruluşa teslim edilecek ise, teslim edilecek kişi/kuruluşun teslimatı kabul</row>
          <row>etmemesinden ADP Endüstriyel Otomasyon sorumlu tutulamaz.</row>       
          </p>
          <p>
          <row><strong> 4.4.</strong></row>
          ADP Endüstriyel Otomasyon, sözleşme konusu ürünün sağlam, eksiksiz, siparişte belirtilen niteliklere uygun ve varsa garanti belgeleri ve kullanım 
          kılavuzları ile teslim edilmesinden sorumludur.     
          </p>
          <p>
          <row><strong> 4.5.</strong></row>
          Sözleşme konusu ürünün teslimatı için bedelinin ALICI'nın tercih ettiği ödeme şekli ile ödenmiş olması şarttır. Herhangi bir nedenle ürün bedeli ödenmez
           veya banka kayıtlarında iptal edilir ise, ADP Endüstriyel Otomasyon ürünün teslimi yükümlülüğünden kurtulmuş kabul edilir.
          </p>
          <p>
          <row><strong> 4.6.</strong></row>
          Ürünün tesliminden sonra ALICI'ya ait kredi kartının ALICI'nın kusurundan kaynaklanmayan bir şekilde yetkisiz kişilerce haksız veya hukuka aykırı olarak 
          kullanılması nedeni ile ilgili,banka veya finans kuruluşunun ürün bedelini ADP Endüstriyel Otomasyon'a ödememesi halinde, ALICI'nın kendisine teslim edilmiş olması
           kaydıyla ürünün 3 gün içinde ADP Endüstriyel Otomasyon'a gönderilmesi zorunludur. Bu takdirde nakliye giderleri ALICI'ya aittir. Eğer ürünler ADP Endüstriyel Otomasyon'a iade
            edilmezse hiçbir ihtar ve ihbara gerek kalmaksızın ürün bedeli olan alacağın muaccel hale geleceğini ALICI gayri kabili rücu olarak kabul, beyan ve taahhüt eder.                          
          </p>
          <p>
          <row><strong> 4.7.</strong></row>
          ADP Endüstriyel Otomasyon mücbir sebepler veya nakliyeyi engelleyen hava muhalefeti, ulaşımın kesilmesi gibi olağanüstü durumlar nedeni ile sözleşme konusu ürünü süresi
          içinde teslim edemez ise, durumu ALICI'ya bildirmekle yükümlüdür. Bu takdirde ALICI siparişin iptal edilmesini, sözleşme konusu ürünün varsa emsali ile
          değiştirilmesini, ve/veya teslimat süresini engelleyici durum ortadan kalkana kadar siparişin ertelenmesi haklarından birini kullanabilir. ALICI'nın siparişi
          iptal etmesi halinde ödediği tutar 15 iş günü içinde kendisine nakden ve defaten ödenir.    
          </p>
          <p>
          <row><strong> 4.8.</strong></row>
          Sitede satışı yapılan tüm ürünler üretici firmaların garantisi altında olup üretici firmaların garanti koşulları geçerlidir. Satılan ürünlerden arızalı veya bozuk olanlar,
          garanti şartları içinde gerekli onarımın yapılması için ADP Endüstriyel Otomasyon'a gönderilebilir, bu takdirde kargo giderleri ALICI tarafından karşılanacaktır.   
          </p>
          <p>
          <row><strong> 4.9.</strong></row>
          İşbu sözleşme, ALICI tarafından onaylanmasından sonra geçerlilik kazanır.   
          </p> 
          <p> <strong>  MADDE 5 - CAYMA HAKKI </strong> </p>
          <p>
          ALICI, sözleşme konusu ürünün kendisine veya gösterdiği adresteki kişi/kuruluşa tesliminden itibaren (7) gün içinde cayma hakkına sahiptir. Cayma hakkının kullanılması
          için bu süre içinde ADP Endüstriyel Otomasyon'a faks, e-posta veya telefon ile bildirimde bulunulması ve ürünün iade koşullarında belirtilen hükümler çerçevesinde kullanılmamış
          olması şarttır. Bu hakkın kullanılması halinde, 3. kişiye veya ALICI'ya teslim edilen ürünün ADP Endüstriyel Otomasyon'a gönderildiğine ilişkin kargo teslim tutanağı örneği ile
          fatura aslı ve kopya suretinin iadesi zorunludur. Bu belgelerin ulaşmasını takip eden 10 gün içinde ürün bedeli ALICI'ya iade edilir. Cayma hakkı nedeni ile iade edilen
          ürünün kargo bedeli ALICI tarafından karşılanır.
          </p>
          <p>
          Niteliği itibariyle iade edilemeyecek ürünler, tek kullanımlık ürünler, kopyalanabilir yazılım ve programlar için ve sitede "Stoktan teslim" ibaresi bulunmayan stok dışı ürünlerde
          cayma hakkı kullanılamaz. Her türlü yazılım ve programlar, DVD, VCD, CD ve kasetler, piller, sarf malzemeleri (toner, kartuş, şerit vb.) gibi ürünlerde cayma hakkının kullanılması,
           ürünün ambalajının açılmamış, bozulmamış ve ürünün kullanılmamış olması şartına bağlıdır.
          Ayrıca, tüketicinin özel istek ve talepleri uyarınca üretilen veya üzerinde değişiklik ya da ilaveler yapılarak kişiye özel hale getirilen mallarda tüketici cayma hakkını kullanamaz.
          </p>
          <p>
          Ödemenin kredi kartı veya benzeri bir ödeme kartı ile yapılması halinde tüketici, kartın kendi rızası dışında ve hukuka aykırı biçimde kullanıldığı gerekçesiyle ödeme işleminin
           iptal edilmesini talep edebilir. Bu halde, kartı çıkaran kuruluş itirazın kendisine bildirilmesinden itibaren 15 iş günü içinde ödeme tutarını tüketiciye iade eder.
          Siparişin sonuçlanması durumunda ALICI işbu sözleşmenin tüm koşullarını kabul etmiş sayılacaktır.
          </p>
      
            
            {/* Add more rows as needed */}
          </div>
        
        );
      



        //----------------------
     
      
    }
    
  }, [order,isLoading]);



  useEffect(() => {
    if (userInfo){ 
    if(userInfo.isAdmin)  {
        setTrig(true);

    }
    else{
        setTrig(false);
    }
    
}
  }, [userInfo]);



const submitHandler = (e) => {

    setTempOrder({...tempOrder,  
    itemsPrice: tempOrder.orderItems.reduce((acc, item) => acc + item.qty * item.price, 0).toFixed(2), 
    taxPrice: ((tempOrder.orderItems.reduce((acc, item) => acc + item.qty * item.price, 0).toFixed(2))*0.2).toFixed(2),
    totalPrice: tempOrder.orderItems.reduce((acc, item) => acc + item.qty * item.price*1.20, 0).toFixed(2),
    });
     setOrderItems(tempOrder.orderItems);
     setTempItemPrice(tempOrder.orderItems.reduce((acc, item) => acc + item.qty * item.price, 0).toFixed(2));
     setTempTaxPrice(((tempOrder.orderItems.reduce((acc, item) => acc + item.qty * item.price, 0).toFixed(2))*0.2).toFixed(2)) ;
     setTempTotalPrice(tempOrder.orderItems.reduce((acc, item) => acc + item.qty * item.price*1.20, 0).toFixed(2)); 
} 


  return (isLoading ) ? (
  <Loader />
  ) : error ? (
  <Message variant="danger" />
  ) : ((tempOrder) &&
    <div style={{ paddingTop: '10px', paddingBottom: '10px', backgroundColor: '#f8f9fa' }}>
      <Container>
        {userInfo ? <CheckoutStatusBar1 step4 locked /> : <CheckoutStatusBar userfill step4 locked />}
        <Row style={{ marginTop: '-20px' }}>
          <Col xs={12} md={8}>
            <Card className="border-0 shadow-sm rounded-4 overflow-hidden mb-4"
              style={{ borderTop: '4px solid #004488', marginTop: '40px', position: 'relative', zIndex: 0 }}>
              <Card.Header className="text-white p-3 border-0" style={{ backgroundColor: '#66CCFF' }}>
                <h4 className="m-0 fw-bold fs-5">Sipariş No: {tempOrder._id}</h4>
              </Card.Header>
              <ListGroup variant='flush'>

                {/* SEVKİYAT */}
                <ListGroup.Item className="p-4 border-bottom">
                  <h5 className="fw-bold mb-3 text-dark"><FaTruck className="me-2 text-muted" /> Sevkiyat</h5>
                  <Row>
                    <Col xs={12} sm={6}>
                      <div className="small text-muted mb-1">Teslimat Adresi:</div>
                      <p className="mb-0 fw-bold">{tempOrder.shippingAddress.receiver}</p>
                      <p className="small mb-0">{tempOrder.shippingAddress.address}, {tempOrder.shippingAddress.city} / {tempOrder.shippingAddress.state}</p>
                    </Col>
                    <Col xs={12} sm={6} className="mt-3 mt-sm-0 border-start ps-4">
                      <p className="small mb-2"><strong>E-Posta:</strong> {tempOrder.shippingAddress.email}</p>
                      <div className="small text-muted mb-1">Seçilen Kargo:</div>
                      <div className="d-flex align-items-center gap-2">
                        {(tempOrder.shippingAddress.cargoSelection==='Yurtiçi Kargo')?(<img src='/images/yurtici.jpg' height="40" alt="Yurtiçi" />):(tempOrder.shippingAddress.cargoSelection==='Aras Kargo' ?(<img src='/images/aras.jpg' height="40" alt="Aras" />):(<img src='/images/mng.jpg' height="40" alt="MNG" />))}
                        <span className="fw-bold small" style={{ color: '#0a5c2b' }}>Ücretsiz Kargo</span>
                      </div>
                    </Col>
                  </Row>

                  {tempOrder.isPaid &&(tempOrder.isDelivered ?(
                      <Message variant='success' className="mt-3">
                          Kargoya verildi {tempOrder.deliveredAt +" Kargo Takip No: "+ tempOrder.deliverNumber}
                      </Message>
                  ):(
                      <Message variant='danger' className="mt-3">Henüz Kargoya verilmedi</Message>
                  ))}
                </ListGroup.Item>

                {/* ÖDEME ŞEKLİ */}
                <ListGroup.Item className="p-4 border-bottom">
                  <h5 className="fw-bold mb-3 text-dark"><FaCreditCard className="me-2 text-muted" /> Ödeme Şekli</h5>
                  <Row>
                    <Col xs={12} md={6}>
                      <p className="mb-2"><strong>Tercih: </strong>{tempOrder.paymentMethod}</p>
                      {tempOrder.paymentMethod==="Kredi Kartı" && !tempOrder.isPaid && !data1 &&
                        <form>
                          <Form.Group className='my-1'>
                            <Form.Control
                              type="text"
                              name="number"
                              placeholder="KART NUMARASI"
                              value= {number}
                              onChange={(e)=> e.target.value.length <17 &&
                                setNumber(e.target.value)}
                              className="py-2 rounded-3 border-secondary-subtle"
                            ></Form.Control>
                          </Form.Group>
                          <p style={{ color: 'red' }} className="small mb-1">{formErrors.number}</p>

                          <Form.Group className='my-1'>
                            <Form.Control
                              type="text"
                              name="name"
                              placeholder="ADI SOYADI"
                              value= {name}
                              onChange={(e)=> setName(e.target.value)}
                              className="py-2 rounded-3 border-secondary-subtle"
                            ></Form.Control>
                          </Form.Group>
                          <p style={{ color: 'red' }} className="small mb-1">{formErrors.name}</p>

                          <Row>
                            <Col xs={6}>
                              <Form.Group className='my-1'>
                                <Form.Control
                                  type="text"
                                  name="expiry"
                                  placeholder="AY/YIL"
                                  value= {expiry}
                                  onChange={(e)=>
                                    e.target.value.length <5 &&
                                    setExpiry(e.target.value)}
                                  className="py-2 rounded-3 border-secondary-subtle"
                                ></Form.Control>
                              </Form.Group>
                              <p style={{ color: 'red' }} className="small mb-1">{formErrors.expiry}</p>
                            </Col>
                            <Col xs={6}>
                              <Form.Group className='my-1'>
                                <Form.Control
                                  type="text"
                                  name="cvv"
                                  placeholder="CVV"
                                  value= {cvv}
                                  onChange={(e)=>
                                    e.target.value.length <4 &&
                                    setCvv(e.target.value)}
                                  className="py-2 rounded-3 border-secondary-subtle"
                                ></Form.Control>
                              </Form.Group>
                              <p style={{ color: 'red' }} className="small mb-1">{formErrors.cvv}</p>
                            </Col>
                          </Row>
                        </form>
                      }
                    </Col>
                    <Col xs={12} md={6} className="mt-3 mt-md-0">
                      {tempOrder.paymentMethod==="Banka Transferi" ? (
                        <div className="p-3 bg-light border border-secondary-subtle rounded-3 small shadow-inner">
                          <strong className="d-block mb-1" style={{ color: '#004488' }}>ADP ENDÜSTRİYEL OTOMASYON SİSTEMLERİ SAN. VE TİC. LTD. ŞTİ.</strong>
                          <div>Kuveyt Türk Katılım Bankası-Fikirtepe Şubesi</div>
                          <div>TRY IBAN: TR82 0020 5000 0977 1989 0000 02</div>
                        </div>
                      ) : ( tempOrder.isPaid  && !data1 ? (
                        <div className="bg-light p-3 border rounded d-inline-block">
                          <Cards
                            cvc={''}
                            expiry={''}
                            name= {''}
                            number ={tempOrder.paymentResult.id}
                          />
                        </div>
                        )
                        :
                        (
                          <div className="bg-light p-3 border rounded d-inline-block">
                            <Cards
                              cvc={cvv}
                              expiry={expiry}
                              name= {name}
                              number ={number}
                            />
                          </div>
                        )
                      )}
                    </Col>
                  </Row>

                  {order.isPaid ? (
                      <Message variant='success' className="mt-3">
                          Ödendi {tempOrder.paidAt}
                      </Message>
                  ):(
                      <Message variant='danger' className="mt-3">Henüz ödenmedi</Message>
                  )}
                </ListGroup.Item>

                {/* ÜRÜN LİSTESİ */}
                <ListGroup.Item className="p-4">
                  <h5 className="fw-bold mb-3 text-dark">Ürün Listesi</h5>
                  <ListGroup variant='flush' className="border rounded-3">
                    { tempOrder.orderItems.map((item,index) =>(
                        <ListGroup.Item key={index} className="py-3">
                          <Row className="align-items-center">
                            <Col xs={2} sm={1}><Image src={item.image} alt={item.name} fluid rounded className="border p-1 bg-white" /></Col>
                            <Col xs={10} sm={6}>
                              <Link to={`/product/${item.product}`} className="fw-bold text-dark small d-block text-decoration-none">
                                {item.name}
                              </Link>
                            </Col>
                            {((tempOrder.isOffered=== true && item.priceShow === false) || trig === true || item.priceShow === true )?
                            <Col xs={12} sm={5} className="text-sm-end fw-bold font-monospace text-secondary" style={{ fontSize: '0.85rem' }}>

                              { (trig=== true & !tempOrder.isOffered) && (<input disabled={tempOrder.isPaid === true} name={item._id} type="number" placeholder="Birim Fiyat" className="form-control form-control-sm mb-1" onChange={(e)=> { setTempOrder({...tempOrder,  orderItems:[...tempOrder.orderItems.map(product=>{
                                if(product===item) return  {...product,  price : parseFloat(e.target.value,2) }
                                else{
                                  return  (product);
                                }
                              })]});

                              } }/>) }

                              {item.priceShow === true ? (
                                <>
                                  {item.qty} x {accounting.formatMoney(item.price - (item.price * (item.discount || 0) / 100),{ symbol: "", precision: 2, thousand: ".", decimal: "," })} ₺ = {accounting.formatMoney(item.qty * (item.price - (item.price * (item.discount || 0) / 100)),{ symbol: "", precision: 2, thousand: ".", decimal: "," })} ₺
                                </>
                              ) : (
                                <>
                                  {item.qty} x {accounting.formatMoney(item.price,{ symbol: "", precision: 2, thousand: ".", decimal: "," })} ₺ = {accounting.formatMoney(item.qty * item.price,{ symbol: "", precision: 2, thousand: ".", decimal: "," })} ₺
                                </>
                              )}
                            </Col>
                             :
                             <Col xs={12} sm={5} className="text-sm-end">
                               <span className="badge bg-warning text-dark">Teklif Bekleniyor</span>
                             </Col>
                             }
                          </Row>
                        </ListGroup.Item>
                    ))}
                  </ListGroup>
                </ListGroup.Item>
              </ListGroup>
            </Card>
          </Col>

          {/* SAĞ KOLON: ÖZET VE İŞLEMLER */}
          <Col xs={12} md={4} className="mt-4 mt-md-0">
            <Card className="border-0 shadow-sm rounded-4 overflow-hidden mb-4"
              style={{ borderTop: '4px solid #004488', marginTop: '40px', position: 'relative', zIndex: 0 }}>
              <Card.Header className="bg-dark text-white p-3 border-0"><h5 className="m-0 fw-bold">Sipariş Özeti</h5></Card.Header>
              <ListGroup variant='flush'>
                <ListGroup.Item className="p-3">
                  {(order.isOffered=== true || trig === true) ? (
                    <>
                      <div className="d-flex justify-content-between mb-1 small"><span>Ürünler:</span> <strong>{accounting.formatMoney(tempOrder.itemsPrice,{ symbol: "", precision: 2, thousand: ".", decimal: "," })} ₺</strong></div>
                      <div className="d-flex justify-content-between mb-2 small"><span>K.D.V (%20):</span> <strong>{accounting.formatMoney(tempOrder.taxPrice,{ symbol: "", precision: 2, thousand: ".", decimal: "," })} ₺</strong></div>
                      <hr className="my-2" />
                      <div className="d-flex justify-content-between align-items-center mb-1">
                        <span className="fw-bold">Toplam:</span>
                        <span className="text-primary fw-bold fs-5">{accounting.formatMoney(tempOrder.totalPrice,{ symbol: "", precision: 2, thousand: ".", decimal: "," })} ₺</span>
                      </div>
                    </>
                  ) : (
                    <div className="text-center text-muted fw-bold py-2">Teklif Bekleniyor</div>
                  )}
                </ListGroup.Item>

                <ListGroup.Item className="p-3 bg-light border-0">
                  <div className="d-flex flex-column gap-2">

                  { tempOrder.isOffered && !tempOrder.isPaid &&
                    <Message variant='success'>Teklif Gönderildi. Ürün fiyatlarını yukarıdaki listeden inceleyebilirsiniz.</Message>
                  }

                  { tempOrder.isOrdered && !tempOrder.isPaid &&
                    <>
                      <Message variant='success'>Siparişiniz Başarı ile başlatıldı.Takibini Siparişlerimden devam edebilirsiniz.</Message>
                      <div onClick={() => setIsModalOpen(true)} className="small fw-bold" style={{ cursor: 'pointer', color: '#004488', textDecoration: 'underline' }}>
                        Mesafeli Satış Sözleşmesi
                      </div>
                      <DocumentModal
                        isOpen={isModalOpen}
                        content={documentContent}
                        onClose={() => (setIsModalOpen(false), setIsEnable(true))}
                      />
                    </>
                  }
                  { tempOrder.isPaid &&
                    <>
                      <Message variant='success' className="d-flex align-items-start gap-2">
                        <FaCheckCircle className="mt-1 flex-shrink-0" />
                        <span>Ödemeniz Alındı. Alışverişiniz için teşekkür ederiz.</span>
                      </Message>
                      <div onClick={() => setIsModalOpen(true)} className="small fw-bold" style={{ cursor: 'pointer', color: '#004488', textDecoration: 'underline' }}>
                        Mesafeli Satış Sözleşmesi
                      </div>
                      <DocumentModal
                        isOpen={isModalOpen}
                        content={documentContent}
                        onClose={() => setIsModalOpen(false)}
                        closeLabel='Kapat'
                      />
                    </>
                  }

                  {loadingDeliver&& <Loader/>}
                  {userInfo && userInfo.isAdmin  && !tempOrder.isDelivered && tempOrder.isPaid && (
                      <Button type='button' className='w-100 border-0 fw-bold'
                        style={{ backgroundColor: '#2b2b2b', color: '#fff', height: '42px', borderRadius: '4px' }}
                        onMouseEnter={(e) => e.target.style.backgroundColor = '#66CCFF'}
                        onMouseLeave={(e) => e.target.style.backgroundColor = '#2b2b2b'}
                        onClick={deliverOrderHandler}>
                        Kargoda İşaretle
                      </Button>
                  )}

                  {loadingOrder&& <Loader/>}

                  {!data1 && tempOrder.paymentMethod==="Kredi Kartı" && tempOrder.isPaid===false && (
                    <>
                      <Button
                        type='button'
                        className='w-100 border-0 fw-bold'
                        style={{ backgroundColor: (isConfirm===false) ? '#aaa' : '#2b2b2b', color: '#fff', height: '42px', borderRadius: '4px' }}
                        disabled={ isConfirm===false}
                        onClick={placeOrderHandler1}
                      >
                        Satın Al
                      </Button>
                      <div className="d-flex align-items-center gap-2 small">
                        {!tempOrder.isPaid&&
                          <Form.Check
                            type="checkbox"
                            checked = {isConfirm}
                            disabled = {isEnable===false}
                            onChange={(e)=> setIsConfirm(e.target.checked)}
                          />
                        }
                        {order &&
                          <span>
                            <span onClick={() => setIsModalOpen(true)} style={{ cursor: 'pointer', color: '#004488', textDecoration: 'underline' }}>
                              Mesafeli Satış Sözleşmesini
                            </span> {(tempOrder.isOrdered || tempOrder.isPaid) ?(''):('kabul ediyorum.')}
                            <DocumentModal
                              isOpen={isModalOpen}
                              content={documentContent}
                              onClose={() => (setIsModalOpen(false), setIsEnable(true))}
                            />
                          </span>
                        }
                      </div>
                      {/*
                        Bankaya 3D Secure kart doğrulama isteğini gönderen gizli form.
                        Gerçek bir tarayıcı POST'u kullanır (fetch/iframe/dangerouslySetInnerHTML
                        DEĞİL) - bkz. PlaceOrderScreen.jsx -> fetchData.
                      */}
                      <form ref={paymentFormRef} method="POST" action="/api/payment/initiate" style={{ display: 'none' }}>
                        <input type="hidden" name="orderId" ref={orderIdRef} />
                        <input type="hidden" name="cardNumber" ref={cardNumberRef} />
                        <input type="hidden" name="expireMonth" ref={expireMonthRef} />
                        <input type="hidden" name="expireYear" ref={expireYearRef} />
                        <input type="hidden" name="cvv" ref={cvvRef} />
                        <input type="hidden" name="cardHolderName" ref={cardHolderNameRef} />
                      </form>
                    </>
                  )}

                  {/* Banka Transferi (veya kart bilgisi henüz gönderilmemiş) ve admin olmayan
                      kullanıcılar için "Siparişi Başlat" - orijinal kodda userInfo var/yok
                      durumlarına göre iki ayrı (ama birebir aynı) dal vardı, tek koşula
                      indirgendi: (!userInfo || !userInfo.isAdmin) && !tempOrder.isOrdered */}
                  {!data1 && tempOrder.paymentMethod!=="Kredi Kartı" && (!userInfo || !userInfo.isAdmin) && !tempOrder.isOrdered && (
                    <>
                      <Button type='button' className='w-100 border-0 fw-bold'
                        style={{ backgroundColor: (isConfirm===false) ? '#aaa' : '#2b2b2b', color: '#fff', height: '42px', borderRadius: '4px' }}
                        disabled={ isConfirm===false}
                        onClick={orderRequestHandler}>
                          Siparişi Başlat
                      </Button>
                      <div className="d-flex align-items-center gap-2 small">
                        {!tempOrder.isOrdered &&
                          <Form.Check
                            type="checkbox"
                            checked = {isConfirm}
                            disabled = {isEnable===false}
                            onChange={(e)=> setIsConfirm(e.target.checked)}
                          />
                        }
                        {order &&
                          <span>
                            <span onClick={() => setIsModalOpen(true)} style={{ cursor: 'pointer', color: '#004488', textDecoration: 'underline' }}>
                              Mesafeli Satış Sözleşmesini
                            </span> {(tempOrder.isOrdered || tempOrder.isPaid) ?(''):('kabul ediyorum.')}
                            <DocumentModal
                              isOpen={isModalOpen}
                              content={documentContent}
                              onClose={() => (setIsModalOpen(false), setIsEnable(true))}
                            />
                          </span>
                        }
                      </div>
                    </>
                  )}

                  {loadingOffer&& <Loader/>}
                  {userInfo && userInfo.isAdmin && !tempOrder.isOffered && (
                      <Button type='button' className='w-100 border-0 fw-bold'
                        style={{ backgroundColor: '#2b2b2b', color: '#fff', height: '42px', borderRadius: '4px' }}
                        onMouseEnter={(e) => e.target.style.backgroundColor = '#66CCFF'}
                        onMouseLeave={(e) => e.target.style.backgroundColor = '#2b2b2b'}
                        onClick={offerSendHandler}>
                        Teklifi Gönder
                      </Button>
                  )}

                  {loadingPay&& <Loader/>}
                  { userInfo && userInfo.isAdmin && !tempOrder.isPaid &&
                  (
                    /* THIS BUTTON IS FOR TESTING! REMOVE BEFORE PRODUCTION! */
                    <Button
                      className='w-100 border-0 fw-bold'
                      style={{ backgroundColor: '#2b2b2b', color: '#fff', height: '42px', borderRadius: '4px' }}
                      onMouseEnter={(e) => e.target.style.backgroundColor = '#66CCFF'}
                      onMouseLeave={(e) => e.target.style.backgroundColor = '#2b2b2b'}
                      onClick={onApproveTest}
                    >
                      Ödendi İşaretle
                    </Button>
                  )}

                  </div>
                </ListGroup.Item>
              </ListGroup>
            </Card>

            {/* ADMIN ARAÇLARI: Teklif güncelleme ve kargo takip no */}
            {userInfo && userInfo.isAdmin && (!tempOrder.isOffered || !tempOrder.isDelivered) && (
              <Card className="border-0 shadow-sm rounded-4 overflow-hidden mb-4" style={{ borderTop: '4px solid #004488' }}>
                <Card.Header className="bg-dark text-white p-3 border-0"><h5 className="m-0 fw-bold">Admin Araçları</h5></Card.Header>
                <ListGroup variant='flush'>
                  {!tempOrder.isOffered && (
                    <ListGroup.Item className="p-3">
                      <div className="small text-muted mb-2">Yukarıdaki ürün listesinden fiyatları güncelledikten sonra toplamı yeniden hesaplamak için:</div>
                      <Button
                        type='button'
                        className='w-100 border-0 fw-bold'
                        style={{ backgroundColor: '#2b2b2b', color: '#fff', height: '42px', borderRadius: '4px' }}
                        onMouseEnter={(e) => e.target.style.backgroundColor = '#66CCFF'}
                        onMouseLeave={(e) => e.target.style.backgroundColor = '#2b2b2b'}
                        onClick={submitHandler}
                      >
                        Teklifi Güncelle
                      </Button>
                    </ListGroup.Item>
                  )}

                  {!tempOrder.isDelivered && (
                    <ListGroup.Item className="p-3">
                      <Form.Label className="fw-bold text-muted small">Kargo Takip No</Form.Label>
                      <Form.Control
                        type="number"
                        value={deliverNumber}
                        onChange={(e)=> setDeliverNumber(e.target.value)}
                        className="py-2 rounded-3 border-secondary-subtle"
                        placeholder="Kargo takip numarasını giriniz"
                      />
                    </ListGroup.Item>
                  )}
                </ListGroup>
              </Card>
            )}
          </Col>

        </Row>
      </Container>
    </div>
  ) ;
  
}

export default OrderScreen